import * as React from 'react';
import { GridContext } from '../grid/grid';
const GridColumn = (props) => {
    const { align, border, children, className, elementRef, id, noGutter, offset, order, width, } = props;
    const { element: rootElement } = React.useContext(GridContext);
    let Element;
    switch (rootElement) {
        case ('ol'):
        case ('ul'):
            Element = 'li';
            break;
        case ('span'):
            Element = 'span';
            break;
        default:
            Element = 'div';
    }
    const BEM = () => {
        const classArray = ['grid__col'];
        if (width) {
            for (const i of width) {
                classArray.push(`grid__col--${i}`);
            }
        }
        else {
            classArray.push('grid__col--xs-12');
        }
        if (offset) {
            for (const i of offset) {
                classArray.push(`grid__col--offset-${i}`);
            }
        }
        if (order) {
            for (const i of order) {
                classArray.push(`grid__col--${i}`);
            }
        }
        if (align) {
            for (const i of align) {
                classArray.push(`grid__col--${i}`);
            }
        }
        if (border) {
            for (const i of border) {
                classArray.push(`grid__col--border-${i}`);
            }
        }
        if (noGutter) {
            classArray.push('grid__col--no-vertical-gutter');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    if (Element === 'li') {
        return (React.createElement(Element, { id: id, className: BEM(), "aria-hidden": props['aria-hidden'], ref: elementRef }, children));
    }
    return (React.createElement(Element, { id: id, className: BEM(), "aria-hidden": props['aria-hidden'], ref: elementRef }, children));
};
export default GridColumn;
